module.exports = __webpack_public_path__ + "img/melon.b5fb75e7.png";